import { useState } from "react"
import { useApi, useLocation } from "utils"
import { SalesMonthlyGroup, SalesMonthlyItem } from "../types/SalesMonthlyType"

export const MONTHLY_APIS = [
  { category: "INVOICE REVENUE", code_budget: "SL_REV", url: "analytic-sales/sales_invoice_revenue/monthly" },
  { category: "INVOICE COGS", code_budget: "SL_COGS", url: "analytic-sales/sales_invoice_cogs/monthly" },
  { category: "INVOICE PROFIT", code_budget: "SL_PROFIT", url: "analytic-sales/sales_invoice_profit/monthly" },
  { category: "INVOICE AVERAGE", code_budget: "SL_AVG", url: "analytic-sales/sales_invoice_average/monthly" },
]

function createEmptyRow(location_name: string, location_id?: number | null, code_budget?: string): SalesMonthlyItem {
  return {
    location_name,
    location_id: location_id ?? null,
    budget_id: null,
    budget: null,
    average: null,
    january: null,
    february: null,
    march: null,
    april: null,
    may: null,
    june: null,
    july: null,
    august: null,
    september: null,
    october: null,
    november: null,
    december: null,
    code_budget
  }
}

export function useSalesMonthlyList(year?: number, locationId?: number | "") {
  const api = useApi()
  const { data: locationOptions } = useLocation()
  const [data, setData] = useState<SalesMonthlyGroup[]>([])
  const [loading, setLoading] = useState(false)

  const fetchData = async () => {
    if (!year) return
    setLoading(true)

    try {
      const groups = await Promise.all(
        MONTHLY_APIS.map(async (apiConfig) => {
          let items: SalesMonthlyItem[] = []

          if (locationId) {
            const locationName = locationOptions?.find(l => l.value === String(locationId))?.label ?? String(locationId)
            try {
              const res = await api.get(apiConfig.url, { params: { year, location_id: locationId } })
              const payload = res.data?.payload?.[0]
              items = [{ ...payload, location_name: locationName, location_id: locationId, code_budget: apiConfig.code_budget }]
            } catch {
              items = [createEmptyRow(locationName, locationId, apiConfig.code_budget)]
            }
          } else {
            const locations = locationOptions ?? []
            items = await Promise.all(
              locations.map(async (loc) => {
                try {
                  const res = await api.get(apiConfig.url, { params: { year, location_id: loc.value } })
                  const payload = res.data?.payload?.[0]
                  return { ...payload, location_name: loc.label, location_id: Number(loc.value), code_budget: apiConfig.code_budget } as SalesMonthlyItem
                } catch {
                  return createEmptyRow(loc.label, Number(loc.value), apiConfig.code_budget)
                }
              })
            )
          }

          return { category: apiConfig.category, code_budget: apiConfig.code_budget, items } as SalesMonthlyGroup
        })
      )
      setData(groups)
    } catch {
      setData([])
    } finally {
      setLoading(false)
    }
  }

  return { monthlyData: data, setMonthlyData: setData, loading, refetch: fetchData }
}
